import React, { useState } from 'react'
import logoLight from './images/kiwi-full-logo.svg'
import loginSideGraphic from './images/login_side_graphic.png'

import { Mail, Lock, Check, Circle, X } from 'react-feather'
import { Link } from 'react-router-dom'
import { Input } from 'reactstrap'
import AxiosInstance from 'utils/AxiosInstance'
import { useDispatch, useSelector } from 'react-redux'

const ConfirmPassword = () => {
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const { theme } = useSelector((state) => state.themeConfig)

  const changePassword = (e) => {
    e.preventDefault()

    const data = {}
    data.hash = localStorage.getItem('token')

    if (password && confirmPassword && password === confirmPassword) {
      data.password = password
    }

    AxiosInstance.post('/users/reset-password', data).then((response) => {
      if (!response) {
        alert('Something went wrong!')
        return
      }

      if (response.success) {
        console.log('Successs', response.success)
      } else {
        alert(response.message)
      }
    })
  }
  return (
    <div className='modern-login'>
      <div className='underlay d-none d-xl-block'></div>

      <div className='d-flex align-items-center h-100'>
        <div className='d-none d-md-block col-md-6 col-lg-7 col-xl-8 px-0'>
          <div className='hero is-fullheight is-image'>
            <div className='hero-body' style={{ height: '100vh' }}>
              <div className='h-100 d-flex align-items-center'>
                <div className='col'>
                  <img
                    className='hero-image-blur'
                    src={
                      theme.background && theme.background.url
                        ? theme.background.url
                        : loginSideGraphic
                    }
                    alt=''
                    aria-hidden='true'
                  />
                  <img
                    className='hero-image'
                    src={
                      theme.background && theme.background.url
                        ? theme.background.url
                        : loginSideGraphic
                    }
                    alt=''
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-6  col-lg-5 col-xl-4 px-0 is-relative'>
          <a className='top-logo mt-md-5 mt-lg-2' href='/'>
            <img
              className='light-image'
              src={
                theme.loginLogo && theme.loginLogo.url
                  ? theme.loginLogo.url
                  : logoLight
              }
              alt=''
            />
            <img
              className='dark-image'
              src='assets/img/logos/logo/logo-light.svg'
              alt=''
            />
          </a>

          <div className='is-form mt-5 px-lg-3'>
            <div className='hero-body'>
              <div className='form-text '>
                <h2>Recover Account</h2>
                <p className='text-sm'>Reset your account password.</p>
              </div>

              <form id='recover-form' className='login-wrapper'>
                <p className='recover-text text-sm'>
                  Set a new password for your account{' '}
                </p>
                <div className='control has-validation'>
                  <Input
                    type='password'
                    className='input'
                    defaultValue={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <small className='error-text'>This is a required field</small>
                  <div className='auth-label'>New Password</div>
                  <div className='auth-icon'>
                    <Lock />
                  </div>
                  <div className='validation-icon is-success'>
                    <div className='icon-wrapper'>
                      <Check />
                    </div>
                  </div>
                  <div className='validation-icon is-error'>
                    <div className='icon-wrapper'>
                      <X />
                    </div>
                  </div>
                </div>
                <div className='control has-validation'>
                  <Input
                    type='password'
                    className='input'
                    defaultValue={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <small className='error-text'>This is a required field</small>
                  <div className='auth-label'>Confirm Password</div>
                  <div className='auth-icon'>
                    <Lock />
                  </div>
                  <div className='validation-icon is-success'>
                    <div className='icon-wrapper'>
                      <Check />
                    </div>
                  </div>
                  <div className='validation-icon is-error'>
                    <div className='icon-wrapper'>
                      <X />
                    </div>
                  </div>
                </div>
                <div className='button-wrap mt-4'>
                  <Link to='/auth/new-login'>
                    <button
                      id='cancel-recover'
                      type='button'
                      className='login-button confirm cancel'
                    >
                      {'Cancel'}
                    </button>
                  </Link>
                  <button
                    type='button'
                    className='login-button confirm'
                    onClick={changePassword}
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmPassword
